"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M8.541 4.589c.927-.79 2.339-.121 2.339 1.085v8.652c0 1.206-1.411 1.874-2.339 1.085L5.873 13.14H4.42c-.787 0-1.42-.64-1.42-1.423V8.282C3 7.5 3.633 6.86 4.42 6.86h1.453L8.54 4.59Zm.915 1.06-.007.006-2.865 2.437a.7.7 0 0 1-.454.167H4.42l-.006.001-.007.005a.025.025 0 0 0-.005.008.023.023 0 0 0-.002.01v3.434c0 .005 0 .008.002.01a.026.026 0 0 0 .005.007.031.031 0 0 0 .007.005l.006.001h1.71a.7.7 0 0 1 .454.167l2.864 2.437a.084.084 0 0 0 .006.005h.001l.002.001.01-.002c.008-.004.011-.009.011-.009s.002-.005.002-.013V5.674l-.001-.013s-.004-.006-.012-.01a.037.037 0 0 0-.01-.002h-.001Zm2.319 1.101a.7.7 0 0 1 .966-.219c1.073.679 1.74 2.01 1.74 3.472 0 1.461-.667 2.795-1.744 3.467a.7.7 0 0 1-.74-1.188c.595-.372 1.083-1.21 1.083-2.279 0-1.067-.487-1.909-1.087-2.288a.7.7 0 0 1-.218-.966Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M13.61 4.435a.7.7 0 0 1 .987-.073C16.072 5.632 17 7.702 17 10.002c0 2.297-.927 4.364-2.399 5.636a.7.7 0 1 1-.915-1.06c1.132-.977 1.914-2.64 1.914-4.576 0-1.939-.784-3.603-1.917-4.58a.7.7 0 0 1-.073-.987Z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=MuteIcon20.js.map